import { useThing } from "@inrupt/solid-ui-react";

function DeleteQuoteButton({ deleteQuote }) {
  const { thing } = useThing();
  return (
    <button className="delete-button" onClick={() => deleteQuote(thing)}>
      Delete
    </button>
  );
}

export default DeleteQuoteButton;
